<script>
import GridSection from 'templates/builder/GridSection';
import GridRow from 'templates/builder/GridRow';
import GridCol from 'templates/builder/GridCol';
import BlockSpacer from 'templates/builder/BlockSpacer';
import BlockContent from 'templates/builder/BlockContent';
import BlockBody from 'templates/builder/BlockBody';
import BlockHeader from 'templates/builder/BlockHeader';
import BlockImage from 'templates/builder/BlockImage';
import BlockButton from 'templates/builder/BlockButton';
import BlockAccordions from 'templates/builder/BlockAccordions';
import BlockCards from 'templates/builder/BlockCards';
import BlockLinkList from 'templates/builder/BlockLinkList';
import BlockBox from 'templates/builder/BlockBox';
import BlockRecurrent from 'templates/builder/BlockRecurrent';
import BlockVuejsComponent from 'templates/builder/BlockVuejsComponent';

const BUILDER_COMPONENTS = {
    grid_section: GridSection,
    grid_row: GridRow,
    grid_col: GridCol,
    block_spacer: BlockSpacer,
    block_header: BlockHeader,
    block_content: BlockContent,
    block_body: BlockBody,
    block_image: BlockImage,
    block_button: BlockButton,
    block_accordions: BlockAccordions,
    block_cards: BlockCards,
    block_link_list: BlockLinkList,
    block_box: BlockBox,
    block_recurrent: BlockRecurrent,
    block_vuejs_component: BlockVuejsComponent,
};
export default {
    name: 'builder-loop',
    props: {
        builder: {
            type: Array,
        },
    },
    render(createElement) {
        const builder = [];

        // recusive render children
        const renderChildrens = (data) => {
            const childrens = [];
            if (data.childrens.length > 0) {
                data.childrens.forEach((item, idx) => {
                    const itemChilds = [];
                    if (item.childrens.length > 0) {
                        itemChilds.push(renderChildrens(item));
                    }
                    childrens.push(
                        createElement(
                            BUILDER_COMPONENTS[item.blockType],
                            {
                                props: item.props,
                            },
                            itemChilds,
                        ),
                    );
                });
            }
            return childrens;
        };

        // render level 1 + children
        this.builder.forEach((block) => {
            builder.push(
                createElement(
                    BUILDER_COMPONENTS[block.blockType],
                    {
                        props: block.props,
                    },
                    renderChildrens(block),
                ),
            );
        });

        // render entire dom tree
        return createElement(
            'div',
            builder,
        );
    },
};
</script>
